const initialState = {
  datos: {},
  loading: true,
  error: null,
  status: null,
  datosBPM: [],
  loadingBPM: true,
  statusBPM: null,
  datosRanking: [],
  loadingRanking: true,
  statusRanking: null,
  loadingTable: false,
  count: {},
  statusCount: null,
  filters: {
    date: {
      fechaStartFinal: null,
      fechaEndFinal: null
    },
    tags: []
  },
  datosModalEvolution: {},
  loadingModalEvolution: true,
  statusModalEvolution: null,
  datosModalTable: [],
  loadingModalTable: true,
  statusModalTable: null,
  datosModalEvolutionFilter: {},
  loadingModalEvolutionFilter: true,
  statusModalEvolutionFilter: null,
  datosModalTableCount: {},
  loadingModalTableCount: true,
  statusModalTableCount: null,
  loadingModalTableNoLoading: false
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/detail_nfa/initialState.js